<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.abm.folders.modals.deleteSubFolder.title')"
    @close="closeDialog" max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"
          />
        </div>
        <div v-if='!errorDelete'>
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            ¿{{ $t('message.abm.folders.modals.deleteSubFolder.label') }} <b>{{ subFolderName }}</b>?
          </p>
          <p class="text-custom-legend text-zt-dark-400">
            {{ $t('message.abm.folders.modals.deleteSubFolder.label') }}
          </p>
        </div>
        <div v-else>
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            {{ messageError }}
          </p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div v-if='!errorDelete' class="zt-modal-footer rounded-b flex justify-end items-center p-4">
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="closeDialog"
          data-vs-button="closeDialog"
        >
          {{ $t('message.abm.folders.modals.deleteSubFolder.buttonSecondary') }}
        </zt-button>
        <zt-button
          class="w-25 relative"
          :loader="loadingButton"
          loaderTxt="Cargando..."
          @click="requestDelete"
          data-vs-button="requestDelete"
        >
          {{ $t('message.abm.folders.modals.deleteSubFolder.buttonPrimary') }}
          <div v-if="!loadingButton && successful"
            class="w-full h-full absolute top-0 left-0 successful flex items-center justify-center"
          >
            <zt-icon name="check" />
          </div>
        </zt-button>
      </div>
      <div v-else class="zt-modal-footer rounded-b flex justify-end items-center p-4">
        <zt-button class="w-25" @click="goToList" data-vs-button="goToList">
          {{ $t('message.abm.folders.modals.deleteSubFolder.buttonOk') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
import Folders from '@/apiClient/Folders'

export default {
  name: 'DeleteSubFolderDialog',
  inject: [ 'activeDeleteDialog', 'resetSubFolderParams' ],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    subFolderName: {
      type: String,
      default: ''
    },
    folderId: {
      type: [String, Number],
      default: null
    },
    subFolderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loadingButton: false,
      preventClose: false,
      errorDelete: false,
      successful: false,
      messageError: ''
    }
  },
  created() {
    this.folderApi = new Folders()
  },
  methods: {
    closeDialog() {
      if (this.preventClose) return
      this.loadingButton = false
      this.errorDelete = false
      this.activeDeleteDialog(false)
    },
    async requestDelete() {
      if (!this.subFolderId) return
      this.loadingButton = true
      this.preventClose = true
      try {
        const id = this.subFolderId
        await this.folderApi.deleteSubFolder({ id })
        this.successful = true
        this.loadingButton = false
        setTimeout(() => {
          this.goToList()
        }, 2000)
      } catch (e) {
        this.loadingButton = false
        this.preventClose = false
        this.errorDelete = true
        this.errorMessage = ''
        if (e.response && e.response.status === 400) {
          const { code } = e.response.data.codes[0]
          this.messageError = this.$t(`message.abm.folders.errors.${code}`)
        }
      }
    },
    async goToList() {
      await this.resetSubFolderParams()
      this.$router.push({
        name: 'subfolder',
        id: this.folderId
      })
    }
  }
}
</script>

<style scoped lang="scss">
.warning-icon {
  font-size: 2.438rem;
  border-color: #FB8C00 !important;
}
.successful {
  background: #54CAA6;
  z-index: 1;
}
.text-custom-legend {
  font-size: 1.125rem;
}
.zt-modal-footer {
  background-color: #EEEEEE;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  button.button-cancel {
    color: #707070!important;
    background-color: transparent!important;
  }
}
</style>
